import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const MenUAShirt = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[9].productName}
				color={product.allGear[9].color}
				size={product.allGear[9].sizes}
				price={product.allGear[9].price}
				img={product.allGear[9].img}
				miniImg1={product.allGear[9].miniImg1}
				miniImg2={product.allGear[9].miniImg2}
				miniImg3={product.allGear[9].miniImg3}
			/>
		</React.Fragment>
	);
};

export default MenUAShirt;
